import { Box, Card, CardProps, Flex, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

import YourAdvisorTeamCard from '../components/YourAdvisorTeamCard';
import DashboardDocumentsCard from '../components/documents/DashboardDocumentsCard';
import DashboardPayoffCard from '../components/payoffCard/DashboardPayoffCard';
import { DealWithFarthestState } from '../utils';

type DashboardStateCardProps = CardProps & {
  header: ReactNode;
  subheader?: ReactNode;
  body: ReactNode;
  image: ReactNode;
  deal?: DealWithFarthestState;
  hideDocs?: boolean;
  hideAdvisors?: boolean;
};

const DashboardStateCard = ({
  header,
  subheader,
  body,
  image,
  deal,
  hideDocs,
  hideAdvisors,
  ...rest
}: DashboardStateCardProps) => {
  return (
    <Flex flexDirection={{ base: 'column', lg: 'row' }} columnGap="20px" rowGap="20px">
      <Flex
        flexDirection="column"
        gap="20px"
        w={{ base: 'full', lg: hideDocs && hideAdvisors ? '100%' : '72%' }}
      >
        <Card
          border="1px solid"
          borderColor="gainsboro"
          shadow="md"
          px="30px"
          py="25px"
          alignItems={{ base: 'center', md: 'start' }}
          {...rest}
        >
          <Flex
            flexDir={{ base: 'column', md: 'row' }}
            justifyContent="space-between"
            minH={{ md: '200px' }}
            w="full"
          >
            <Flex flexDir="column" maxW={{ lg: '60%' }} mr={{ md: 4 }} pr={2}>
              <Text
                fontWeight="bold"
                fontSize="42px"
                lineHeight="50px"
                my={2}
                textAlign={{ base: 'center', md: 'left' }}
              >
                {header}
              </Text>
              {subheader && (
                <Text
                  fontWeight="bold"
                  fontSize="18px"
                  mt={2}
                  mb={4}
                  textAlign={{ base: 'center', md: 'left' }}
                >
                  {subheader}
                </Text>
              )}
              <Box mt={6}>{body}</Box>
            </Flex>
            {image && (
              <Box
                maxW={{ base: '350px', md: undefined }}
                w="full"
                m={{ base: '20px auto 0 auto', md: 'auto' }}
              >
                {image}
              </Box>
            )}
          </Flex>
        </Card>
        <DashboardPayoffCard deal={deal} />
      </Flex>
      {(!hideDocs || !hideAdvisors) && (
        <Box w={{ base: 'full', lg: '28%' }}>
          {!hideDocs && <DashboardDocumentsCard deal={deal} />}
          {!hideAdvisors && <YourAdvisorTeamCard />}
        </Box>
      )}
    </Flex>
  );
};

export default DashboardStateCard;
